<template>
  <div class="layout">
      <div class="row">
      <span class="left">
        <h4 is="sui-header">Batches</h4>
        <sui-button @click="generateNewHandler">Generate New</sui-button>
        <sui-divider hidden />
        <simple-table :data="$store.state.admin.activationCodeBatches"
                      :columns="stBatchesColumns"
                      :selectable="true"
                      @select="batchSelectHandler"
                      id-field="Batch"
                      :num-rows="14"
                      :st-api="stBatchesApi"/>
      </span>
      <span class="right" v-if="selectedBatch">
        <h4 is="sui-header">Activation Codes of {{this.selectedBatch.Batch}}</h4>
        <sui-button @click="downloadQRCodesHandler" :disabled="!codesAvailable">Download QR Codes</sui-button>
        <sui-divider hidden />
        <simple-table :data="$store.state.admin.activationCodes" :columns="stCodesColumns" :stretch="true" :num-rows="14" />
      </span>
    </div>
  </div>
</template>

<script>
    import SimpleTable from "../simple-table/SimpleTable";
    import moment from 'moment'
    export default {
      name: "ActivationCodeManagement",
      components: {SimpleTable},
      data: function() {
        return {
          selectedBatch: null,
          stBatchesApi: {},
          stBatchesColumns: [
            {header: "created", field: "Created", format:"dateTime"},
            {header: "name", field: "Batch"},
            {header: "total", field: "Size"},
            {header: "taken", field: "AssignedDevices"},
          ],
          stCodesColumns: [
            {header: "created", field: "Created", format:"dateTime"},
            {header: "activation code", field: "ActivationCode"},
            {header: "assigned device", field: "DeviceID", format: "assignedDevice"},
          ],
        }
      },
      computed: {
        codesAvailable() {
          let codes = this.$store.state.admin.activationCodes || []
          for (let i = 0; i < codes.length; i++) {
            if (!codes[i].DeviceID) {
              return true
            }
          }
          return false
        }
      },
      methods: {
        async batchSelectHandler(item) {
          this.selectedBatch = item
          await this.loadBatch()
        },
        async reload(preselectBatchID) {
          await this.$store.dispatch('admin/listActivationCodeBatches')
          if (this.$store.state.admin.error) return
          if ((this.$store.state.admin.activationCodeBatches || []).length === 0) return
          if (preselectBatchID) {
            this.stBatchesApi.selectById(preselectBatchID)
          } else {
            this.stBatchesApi.selectById(this.$store.state.admin.activationCodeBatches[0].Batch)
          }
        },
        async loadBatch() {
          if (!this.selectedBatch) return
          await this.$store.dispatch('admin/listActivationCodes', this.selectedBatch.Batch)
        },
        async generateNewHandler() {
          let confirmation = confirm(`Are you sure you want to generate a new batch (50 codes)?`);
          if (confirmation) {
            let batchName = moment().format('YYYY-MM-DD HH:mm:ss')
            await this.$store.dispatch('admin/generateActivationCodeBatch', {size: 50, name: batchName})
            if (this.$store.state.admin.updateResult === true) {
              this.reload(batchName)
            }
          }
        },
        async downloadQRCodesHandler() {
          if (!this.selectedBatch) return
          await this.$store.dispatch('admin/downloadActivationCodeBatch', this.selectedBatch.Batch)
        }
      },
      async mounted() {
        this.reload();
      },
    }
</script>

<style scoped lang="less">
  .layout {
    display: table;
    width: 100%;
    .row {
      display: table-row;
      .left {
        display: table-cell;
        vertical-align: top;
        padding: 10pt 20pt 10pt 0pt;
      }
      .right {
        display: table-cell;
        width: 100%;
        padding: 10pt 20pt;
        border-left: 1px solid #F0F0F0;
      }
    }
  }

</style>
